// New helper class to initiate NHS OAuth authentication flows
export default class NhsAuthHelper {
  // Generate a cryptographically-secure random string which will be sent as the OAuth state
  static generateRandomState() {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  }

  // Build the CIS2 Care Identity authentication URL
  static buildAuthUrl(state) {
    const authUrl = new URL(process.env.REACT_APP_NHS_AUTH_URL);
    authUrl.searchParams.append('response_type', 'code');
    authUrl.searchParams.append('client_id', process.env.REACT_APP_NHS_CLIENT_ID);
    authUrl.searchParams.append('redirect_uri', process.env.REACT_APP_NHS_REDIRECT_URI);
    authUrl.searchParams.append('scope', 'openid profile associatedorgs');
    authUrl.searchParams.append('state', state);
    authUrl.searchParams.append('acr_values', 'AAL2_OR_AAL3_ANY');
    authUrl.searchParams.append('max_age', '30');
    return authUrl.toString();
  }

  /**
   * Start the OAuth flow.
   * @param {Object} options
   * @param {('login'|'onboard')} options.purpose  Purpose of the flow – standard login or onboarding (linking) flow.
   * @param {string} [options.email]  Email of the currently logged-in user – required for onboarding.
   */
  static startAuth({ purpose, email } = {}) {
    if (!purpose) {
      throw new Error('NhsAuthHelper.startAuth requires a purpose parameter');
    }

    // Generate and persist state so it can be validated in the callback
    const state = this.generateRandomState();
    sessionStorage.setItem('oauth_state', state);
    sessionStorage.setItem('oauth_action', purpose);

    // Persist the email only for onboarding – will be needed in the callback
    if (purpose === 'onboard') {
      if (!email) {
        throw new Error('Email must be supplied when purpose is "onboard"');
      }
      sessionStorage.setItem('oauth_email', email);
    } else {
      // Ensure no stale email is left in storage
      sessionStorage.removeItem('oauth_email');
    }

    // Redirect browser to Care Identity Service
    const authUrl = this.buildAuthUrl(state);
    console.log('Redirecting to NHS OAuth URL:', authUrl);
    window.location.href = authUrl;
  }
} 